import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get, postFile} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
    success:''
}

export const fetchCareer = createAsyncThunk("fetchCareer", (params, {dispatch}) => {
    return get(params);
});

export const postForm = createAsyncThunk("careerForm", (params) => {
    return postFile(params);
});

const postSlice = createSlice({
    name: 'career',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchCareer.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchCareer.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchCareer.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
        builder.addCase(postForm.pending, (state) => {
            state.loading = true;
            state.success = [];
            state.error = "";
        });
        builder.addCase(postForm.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.error = "";

        });
        builder.addCase(postForm.rejected, (state, action) => {
            state.loading = false;
            state.success = '';
            state.error = action.error;

        });
    }
})


export default postSlice.reducer
